import { tooltip } from './index'

// @ts-ignore
window.tooltipComponent = tooltip
